<template>
  <b-modal id="prompt-modal" centered hide-header-close hide-footer>
    <div slot="modal-title">
      {{ parameters.title }}
    </div>
    <b-container>
      <b-row class="my-3">
        <b-col class="text-center">
          {{ parameters.message }}
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col class="mx-auto" md="3">
          <b-btn
            pill
            block
            variant="primary"
            @click="$root.$emit('bv::hide::modal', 'prompt-modal')"
          >
            {{ parameters.buttonText }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: "PromptModal",
  props: ["parameters"],
};
</script>

<style lang="scss">
#prompt-modal {
  .modal-title {
    width: 100%;
    text-align: center;
  }
  .btn-primary {
    background-color: #ff6b00;
    border-color: #ff6b00;
    font-family: SKModernistBold, sans-serif;
    font-size: 16px;
    border-radius: 5px;
  }
  .btn-primary:hover {
    background: #ff912b;
    color: #ffffff;
  }
  .btn-primary:focus {
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }
}
</style>